





























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import DepressionMixin from '@/views/treatment/depression/DepressionMixin'

export default Vue.extend({
  mixins: [DepressionMixin],
  computed: {
    ...mapGetters('workflow', ['isDone']),
  },
  data() {
    return {
      agreedToAntiSuicideContract: false,
      emergencyContact: '',
      nextSessionStartInDays: new Date(),
      today: new Date(),
    }
  },
})
